import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"

import BaseLayout from "components/BaseLayout"
import CustomButton from "components/Common/CustomButton"
import { ApiTable } from "components/Common/Table"

import { getTreeList } from "helpers/backend_helper"
import { dateToStr } from "helpers/cms_helper"
import {
  DISTRICT_OPTIONS,
  LISTING_STATUS_REJECTED,
  TREE_SUBMISSION_STATUS_DISPLAY,
  TREE_SUBMISSION_STATUS_OPTIONS,
} from "."

import { Link, useHistory } from "react-router-dom"
// Store
import { connect } from "react-redux"
import { exportRecords } from "helpers/exportReportApi"
import { downloadFile } from "helpers/downloadFile"
import { useList } from "hooks/useList"
import { Row } from "reactstrap"
import { rhetoricalOptions } from "helpers/data_helper"

const TreeSubmissionList = ({ treeOptions = [] }) => {
  const tableRef = useRef(null)
  const [loading, setLoading] = useState(true)
  const history = useHistory()
  const [exportList, setExportList] = useList()

  // const editing = !!editingRow
  const treeSpeciesOptions = [
    { label: "Species not provided", value: "species not provided" },
  ].concat(treeOptions)
  const columns = [
    { title: "Tree ID#", value: "displayId" },
    {
      title: "Tree Listing Submission Date",
      value: "submittedAt",
      format: "date",
    },
    {
      title: "Submitted by",
      value: (row) => row?.submittedBy?.username || "",
    },
    {
      title: "Status",
      value: (row) => TREE_SUBMISSION_STATUS_DISPLAY[row?.status] || "",
    },
    {
      title: "Keep it as hidden",
      value: (row) =>
        row?.keepHiddenDate
          ? `Y, ${dateToStr(row?.keepHiddenDate, "MMM D, YYYY")}`
          : "",
    },
    { title: "Last Update Date", value: "updatedAt", format: "date" },
    { title: "Verified At", value: "verifiedAt", format: "date" },
    {
      title: "Has Missing Metrics?",
      value: (row) => {
        if (row.status === LISTING_STATUS_REJECTED) {
          return "N/A"
        }

        return row.isMetricsMissing ? "Yes" : "No"
      },
    },
  ]

  const filters = [
    {
      rowId: 0,
      rowName: "Filter",
      fields: [
        {
          placeholder: "Search by Tree ID# ",
          name: "treeListingNo",
          type: "text",
          icon: "search",
        },
        {
          placeholder: "Search by Submitted By",
          name: "submittedBy",
          type: "text",
          icon: "search",
        },
      ],
    },
    {
      rowId: 1,
      rowName: " ",
      fields: [
        {
          placeholder: "Search by Tree Species",
          name: "treeSpecies",
          type: "select",
          options: treeSpeciesOptions,
        },
        {
          placeholder: "Has Missing Metrics?",
          name: "isMetricsMissing",
          type: "select",
          options: rhetoricalOptions,
        },
      ],
    },
    {
      rowId: 2,
      rowName: " ",
      fields: [
        {
          placeholder: "All Status",
          name: "status",
          type: "select",
          options: TREE_SUBMISSION_STATUS_OPTIONS,
          multiple: true,
        },
        {
          placeholder: "Filter by district",
          name: "district",
          type: "select",
          options: DISTRICT_OPTIONS,
          multiple: true,
        },
        {
          placeholder: "Keep it as hidden",
          name: "keepHidden",
          type: "select",
          options: [{ label: "Y", value: true }],
        },
      ],
    },
    {
      rowId: 3,
      rowName: " ",
      fields: [
        {
          name: "submissionDateFrom",
          type: "datetime",
          placeholder: "Submission Date From",
        },
        {
          name: "submissionDateTo",
          type: "datetime",
          placeholder: "Submission Date To",
        },
      ],
    },
  ]

  async function fetch(params) {
    return getTreeList(params)
  }

  // set current page
  function setCurrentPage() {
    const currentPage = tableRef?.current?.state?.currentPage
    localStorage.setItem("tree-submission-page", currentPage)
  }

  async function handleExportReport() {
    const res = await exportRecords([])

    downloadFile(res.signedUrl, "tree_records.csv")
  }

  async function handleExportSelectedRecords() {
    const res = await exportRecords(exportList)

    downloadFile(res.signedUrl, "selected_tree_record.csv")
    setExportList.clear()
  }

  const handleSelect = (state, value) => {
    if (Array.isArray(value)) {
      const currentPageData = tableRef?.current?.state?.datas || []
      const currentPageIds = currentPageData.map((row) => row.id)
      currentPageIds.forEach((id) => {
        setExportList.toggleItem(id)
      })
    } else {
      setExportList.toggleItem(value.id)
    }
  }

  useEffect(() => {
    if (
      !loading &&
      localStorage.getItem("tree-submission-page") &&
      localStorage.getItem("locationFrom") === history?.location?.pathname
    ) {
      const page = parseInt(localStorage.getItem("tree-submission-page"), 10)
      tableRef?.current?.handlePageChange(page)
      localStorage.removeItem("tree-submission-page")
      localStorage.removeItem("locationFrom")
    }
  }, [loading])

  return (
    <BaseLayout title="All Records">
      <Row className="mb-4">
        <div className="ml-auto tree_submission_control">
          <CustomButton
            type="button"
            className="btn-dark mr-2"
            onClick={handleExportReport}
          >
            Export All
          </CustomButton>
          <CustomButton
            type="button"
            className="btn-outline-dark"
            onClick={handleExportSelectedRecords}
          >
            Export Selected
          </CustomButton>
        </div>
      </Row>

      <ApiTable
        fetchOnMount
        ref={tableRef}
        name="tree-submission-list"
        fetch={fetch}
        columns={columns}
        filters={filters}
        setCustomFetchOnMount={setLoading}
        selectable={true}
        onSelect={handleSelect}
        selected={exportList}
        rowButtons={(row) => (
          <Link
            to={{
              pathname: `/tree-listings/${row.id}`,
              state: { from: history?.location?.pathname },
            }}
          >
            <CustomButton onClick={setCurrentPage} className="btn-outline-dark">
              View
            </CustomButton>
          </Link>
        )}
      />
    </BaseLayout>
  )
}

const mapStatetoProps = (state) => {
  const { treeOptions } = state.tree
  return { treeOptions }
}

export default connect(mapStatetoProps, {})(TreeSubmissionList)

TreeSubmissionList.propTypes = {
  treeOptions: PropTypes.array,
}

TreeSubmissionList.defaultProps = {
  treeOptions: [],
}
